import GlobalIcon2 from "../icons/globalIcon2";
export default function LeftLine1() {
  return (
    <span className="flex gap-c9 justify-start items-center">
      <GlobalIcon2/>
      <span>{"ENGLISH (US)"}</span>
    </span>
  );
}
